var exports = {
  "w": "actionListOverrides__04H7C4",
  "Y": "groupHeading__wLINjF",
};

module.exports = exports;
